import { render } from "./file-manager.vue?vue&type=template&id=22f38b43"
import script from "./file-manager.vue?vue&type=script&lang=js"
export * from "./file-manager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__